import { ComponentBootstrap } from '@demant/wdh-react-bootstrap';
import BlogCategoriesApp from './react-blog-categories';
var componentName = 'blog-categories';
var ReactBlogCategories = new ComponentBootstrap(componentName);
ReactBlogCategories.reactApp = BlogCategoriesApp;
ReactBlogCategories.run();